import { useEffect } from "react";
import { useIntl } from "react-intl";
import ReactGA from "react-ga4";
import InnerHeader from "../../component/shared/innerheader/InnerHeader.js";
import ContentLoading from "component/LoadingComponent/ContentLoading";
import { END_POINTS } from "constants/APIConstant";
import { useContactUsData } from "./useContactUsData";
import HeadQuarterSection from "./components/HeadQuarterSection";
import AdditionalOfficesSection from "./components/AdditionalOfficesSection";
import RegionalOfficesSection from "./components/RegionalOfficesSection";
import "./ContactUs.scss";

function ContactUs() {
  const intl = useIntl();
  const {
    dir,
    currentLocale,
    filters,
    onFilterChange,
    isLoading,
    headQuarter,
    headQuarterLocations,
    branchLocations,
    governorates,
    regionalOffices,
    additionalOffices,
  } = useContactUsData();

  useEffect(() => {
    const timeOut = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
    return () => clearTimeout(timeOut);
  }, []);

  useEffect(() => {
    ReactGA.initialize(END_POINTS.TRACKING_ID);
    ReactGA.send({
      hitType: "pageview",
      page: "/contact",
      title: "Contactus Page",
    });
  }, []);

  return (
    <ContentLoading isLoading={isLoading} className="contact-us">
      <InnerHeader
        breadcrumb={[
          {
            title: intl.formatMessage({ id: "contact-us" }),
            clickClass: true,
          },
        ]}
        title={intl.formatMessage({ id: "contact-need" })}
      />
      <div className="container">
        <div className="row pt-3">
          <HeadQuarterSection
            dir={dir}
            currentLocale={currentLocale}
            headQuarter={headQuarter}
            headQuarterLocations={headQuarterLocations}
          />
          <AdditionalOfficesSection
            dir={dir}
            additionalOffices={additionalOffices}
          />
        </div>
      </div>
      <RegionalOfficesSection
        dir={dir}
        currentLocale={currentLocale}
        filters={filters}
        onFilterChange={onFilterChange}
        governorates={governorates}
        regionalOffices={regionalOffices}
        branchLocations={branchLocations}
      />
    </ContentLoading>
  );
}

export default ContactUs;
